import React from "react"
import cheerio from "cheerio"

function styleStringToObject(styleStr) {
  return styleStr.split(";").reduce((acc, pair) => {
    const [name, ...valueParts] = pair.trim().split(":")
    return {
      ...acc,
      [name.trim()]: valueParts.join(":").trim(),
    }
  }, {})
}

const startTagRegex = /^<(.+?)>/

function htmlToReactElementWithInnerHtml(origHtml, htmlCompRef) {
  if (!origHtml) {
    return null
  }
  let htmlDOM = cheerio.load(
    origHtml
      .trim()
      .replace("<html><head></head><body>", "")
      .replace("</body></html>", "")
  )
  let singleNodes = []
  htmlDOM("body")
    .children()
    .each(function(i, node) {
      if (htmlDOM(this).type !== "text") {
        singleNodes.push(
          buildReactElementWithInnerHtml(htmlDOM.html(this), htmlCompRef)
        )
      }
    })
  return singleNodes
}

function buildReactElementWithInnerHtml(html, htmlCompRef) {
  const rootTagContentMatch = startTagRegex.exec(html)

  if (!rootTagContentMatch) {
    return null
  }

  const [fullMatch, content] = rootTagContentMatch
  const htmlAttrsRegex = /\s([a-zA-Z0-9_:-]+)="(.+?)"/g

  let match
  const argPairs = []
  while ((match = htmlAttrsRegex.exec(content))) {
    argPairs.push([match[1], match[2]])
  }

  const [rootTag] = content.split(" ")

  const rootProps = argPairs.reduce(
    (acc, [name, value]) => ({
      ...acc,
      [name.replace("class", "className")]:
        name === "style" ? styleStringToObject(value) : value,
    }),
    {}
  )

  // work around cheerio issue with xlink-attributes
  const useregex = /<use href="([a-zA-Z0-9_#-]+)"\/>/gm
  html = html.replace(useregex, function(match, p1, offset, string) {
    return `<use xlink:href="${p1}" href="${p1}"></use>`
  })
  return React.createElement(rootTag, {
    key: Math.floor(Math.random() * 1000 + 1),
    ref: htmlCompRef,
    dangerouslySetInnerHTML: {
      __html: html.slice(fullMatch.length, html.lastIndexOf(`</${rootTag}>`)),
    },
    ...rootProps,
  })
}

export { htmlToReactElementWithInnerHtml }
